import QuillMarkdown from './src/app.js'

if (typeof window !== 'undefined') {
  window.QuillMarkdown = QuillMarkdown
}

export default QuillMarkdown
